import React, { useEffect, useRef, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'

import DirectoriesTitle from '../components/directories_title'
import FiltersLabelComponent from '../components/filters_label_component'
import DirectoriesFiltersContainer from '../containers/directories_filters_container'
import DirectoriesContentContainer from '../containers/directories_content_container'
import { Container } from 'react-bootstrap/lib/Tab'
import IntlPolyfill from 'react-intl-polyfill'

const DirectoriesComponent = ({
  customerName,
  directoryName,
  tourName,
  dataIsLoading,
  filters,
  myRegistrationsVisible,
  directoryDescription,
  shouldShowLotteryFilter,
  shouldShowFilters,
  shouldHideHeader,
}) => {

  let filterClass = 'categories-filters-wrapper'
  if (!shouldShowFilters) {
    filterClass += ' hidden'
  }
  let subtitle = directoryName
  if (directoryName === 'Local Tournaments') {
    if (tourName) {
      subtitle = directoryName + ' ● ' + tourName
    }
  }

  return (
    <>
      <IntlPolyfill locales={[ 'en', 'fr', 'vi' ]}>
        <div id="directories_content">
          <div>
            <DirectoriesTitle
              title={customerName}
              subtitle={subtitle}
              description={directoryDescription}
              shouldHideHeader={shouldHideHeader}
            />

            <Row className={filterClass}>
              <Col xs={true}>
                  <DirectoriesFiltersContainer />
              </Col>
            </Row>

            <FiltersLabelComponent
              filters={filters}
              dataIsLoading={dataIsLoading}
              myRegistrationsVisible={myRegistrationsVisible}
              shouldShowLotteryFilter={shouldShowLotteryFilter}
            />
          </div>
          <div>
            <DirectoriesContentContainer  
              dataIsLoading={dataIsLoading}
              allDataIsLoading={false}
            />
          </div>
        </div>
      </IntlPolyfill>
    </>
  )
}

DirectoriesComponent.propTypes = {
  shouldLoadData: PropTypes.bool,
  fetchData: PropTypes.func,
  fetchMoreData: PropTypes.func,
  customerName: PropTypes.string,
  directoryName: PropTypes.string,
  tourName: PropTypes.string,
  tourId: PropTypes.string,
  changeFilter: PropTypes.func,
  dataIsLoading: PropTypes.bool,
  filters: PropTypes.shape({
    status: PropTypes.array,
    startDate: PropTypes.string,
  }),
  myRegistrationsVisible: PropTypes.bool,
  directoryDescription: PropTypes.string,
  shouldShowLotteryFilter: PropTypes.bool,
  shouldShowFilters: PropTypes.bool,
  shouldHideHeader: PropTypes.bool,
}

export default DirectoriesComponent